import { setIsLoading, setSuccess, setError } from './settings-slice';

import { getAppConfig } from 'api/app-config';
import { getErrors } from 'api/client';

import type { TAppConfigProfile } from 'config/app-config';
import type { TError } from 'api/client';
import type { Dispatch } from '@reduxjs/toolkit';

export const getAppConfigThunk = (configId: TAppConfigProfile) => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(setIsLoading({ configId }));
    const response = await getAppConfig(configId);

    dispatch(setSuccess({ configId, data: response }));

    return Promise.resolve();
  } catch (e) {
    const errors = getErrors(e as TError);
    errors && dispatch(setError({ configId, errors }));

    return Promise.reject(errors);
  }
};
